
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProductCTA from "@/components/ProductCTA";
import ProductImages from "@/components/product/ProductImages";
import ProductInfo from "@/components/product/ProductInfo";
import ProductTabs from "@/components/product/ProductTabs";
import RelatedProducts from "@/components/product/RelatedProducts";
import RecommendedProducts from "@/components/product/RecommendedProducts";
import ProductNotFound from "@/components/product/ProductNotFound";
import { products, productFaqs } from "@/data/products";

const ProductDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const product = slug ? products[slug as keyof typeof products] : null;
  
  if (!product) {
    return <ProductNotFound />;
  }

  const faqs = productFaqs[slug as keyof typeof productFaqs] || [];

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow py-12">
        <div className="container-custom">
          <Link to="/shop" className="inline-flex items-center text-muted-foreground hover:text-primary transition-colors mb-6">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Shop
          </Link>

          {/* Product Overview */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            {/* Product Images */}
            <ProductImages images={product.images} productName={product.name} />

            {/* Product Details */}
            <ProductInfo product={product} />
          </div>

          {/* Product Details Tabs */}
          <ProductTabs 
            features={product.features} 
            directions={product.directions} 
            ingredients={product.ingredients}
            faqs={faqs}
          />

          {/* Related Products */}
          <RelatedProducts products={product.relatedProducts} />

          {/* Recommended Products */}
          <RecommendedProducts />
        </div>
      </main>
      <Footer />
      
      {/* Floating ProductCTA */}
      <ProductCTA 
        variant="floating" 
        productName="Breathe Naturals Deodorant" 
        productImage="/lovable-uploads/a2ef7eb0-0c25-4d2e-885a-ecbd6e258b4a.png"
        message="Try our Breathe Naturals deodorant" 
        linkType="breathe1" 
      />
    </div>
  );
};

export default ProductDetail;
